import { Component, OnInit } from "@angular/core";
import * as _ from 'lodash';
import { TaskShareService } from "./task-share.service";
import { ITask } from "../task.interface";
import { MatDialog, MatDialogConfig, MatDialogRef } from "@angular/material/dialog";
import notify from "devextreme/ui/notify";
import { ExternalRequestService } from "../../../../shared/components/external-request/external-request.service";
import { BillingDocumentService } from "../../../billing-documents-page/billing-documents/billing-documents.service";
import { AuthService } from "../../../../shared/services/auth.service";
import { AlertService } from "../../../../shared/services/alert.service";
import { watsappURL } from "../../../../../env-config";

let self: any;

@Component({
  selector: 'app-task-share',
  templateUrl: './task-share.component.html',
  styleUrls: ['./task-share.component.css']
})
export class TaskShareComponent implements OnInit {
  dialog: MatDialogRef<any>;
  loading = false;
  task!: ITask;
  link: any = null;
  saving: boolean = false;
  sending: boolean = false;
  showDownload: boolean = true;
  showEmail: boolean = true;
  showWhatsapp: boolean = true;

  constructor(
    public dialogRef: MatDialogRef<any>,
    public _TaskShareService: TaskShareService,
    private _ExternalRequestService: ExternalRequestService,
    private _BillingDocumentService: BillingDocumentService,
    private _AuthService: AuthService,
    private _AlertService: AlertService,
  ) {
    self = this;
    this.dialog = dialogRef;
  }

  ngOnInit() {

  }

  download() {
    this.saving = true;
    if (this.task.status == 'QUOTED') {
      this._TaskShareService.downloadQuote(this.task._id);
      setTimeout(() => {
        this.saving = false;
      }, 2000);
    } else if (this.task.status == 'INVOICED') {
      this._BillingDocumentService.getBillingDocuments({
        filters: {},
        task: this.task._id,
        company: this._AuthService.companyId()
      }).subscribe(documents => {
        if (documents.length == 0) return this._AlertService.error('Factura no encontrada');
        if (documents.length > 1) return this._AlertService.error('Inclusion multiple en documento. Contactar al administrador');
        this._TaskShareService.downloadBillingDocument(documents[0]._id);
          setTimeout(() => {
          this.saving = false;
          }, 2000);
      });
    }
  }

  sendEmail() {
    this.sending = true;
    let data = {};

    if (this.task.status == 'QUOTED') {
      this._TaskShareService.sendEmailQuote(this.task._id, data).subscribe((result: any) => {
        result ? notify(`Email enviado correctamente`, "info", 1500) : notify(`Error al enviar email`, "error", 1500);
        this.sending = false;
      });
    } else if (this.task.status == 'INVOICED') {

      this._BillingDocumentService.getBillingDocuments({
        filters: {},
        task: this.task._id,
        company: this._AuthService.companyId()
      }).subscribe(documents => {
        if (documents.length == 0) return this._AlertService.error('Factura no encontrada');
        if (documents.length > 1) return this._AlertService.error('Inclusion multiple en documento. Contactar al administrador');
  
        this._TaskShareService.sendEmailBillingDocument(documents[0]._id, data).subscribe((result: any) => {
          result ? notify(`Email enviado correctamente`, "info", 1500) : notify(`Error al enviar email`, "error", 1500);
          this.sending = false;
        });
      });
      
    }

  }

  async shareByWhatsapp() {
    const response = await this._ExternalRequestService.getQuotePdf(this.task);
    this.link = this._ExternalRequestService.getExternalRequestUrl(response._id);
    let phone = this.task.client?.phones[0];
    window.open(watsappURL({ text: `${"Le adjunto link del comprobante"} ${this.link}`, phone: phone.number }))
  }


}